var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTwitter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 17,
    viewBox: "0 0 18 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_51_1711)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.0998 3.58588C16.4751 3.84688 15.8094 4.01988 15.1153 4.10388C15.8293 3.69788 16.3743 3.05988 16.6305 2.29088C15.9648 2.66888 15.2298 2.93588 14.4465 3.08488C13.8144 2.44388 12.9135 2.04688 11.9307 2.04688C10.0239 2.04688 8.48875 3.52088 8.48875 5.32788C8.48875 5.58788 8.51185 5.83787 8.56855 6.07587C5.7052 5.94287 3.17155 4.63588 1.4695 2.64488C1.17235 3.13588 0.998055 3.69788 0.998055 4.30288C0.998055 5.43888 1.6123 6.44587 2.5279 7.02887C1.97455 7.01887 1.4317 6.86588 0.971805 6.62488C0.971805 6.63488 0.971805 6.64787 0.971805 6.66087C0.971805 8.25487 2.16565 9.57887 3.7312 9.88387C3.45085 9.95687 3.1453 9.99187 2.8282 9.99187C2.6077 9.99187 2.3851 9.97987 2.17615 9.93587C2.6224 11.2349 3.8887 12.1899 5.3944 12.2209C4.2226 13.0939 2.73475 13.6199 1.12405 13.6199C0.841605 13.6199 0.570705 13.6079 0.299805 13.5749C1.82545 14.5119 3.63355 15.0469 5.5834 15.0469C11.9212 15.0469 15.3862 10.0469 15.3862 5.71288C15.3862 5.56788 15.381 5.42788 15.3736 5.28888C16.0572 4.82688 16.6315 4.24988 17.0998 3.58588Z",
    fill: "#2E392F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_51_1711"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16.8,
    height: 16,
    fill: "white",
    transform: "translate(0.299805 0.546875)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.6af337e55fb751c1c625b19f56f23cea.svg";
export { ForwardRef as ReactComponent };